import { IonContent, IonPage, IonCol, IonRow, IonGrid, IonList, IonItem, IonLabel, IonIcon, IonRefresher, IonRefresherContent, IonCard, IonCardHeader, IonCardContent, IonCardTitle, IonNote, IonToggle, IonButton, IonSpinner, useIonViewDidEnter, IonToast, IonPopover, IonAlert, IonSearchbar } from '@ionic/react';
import React, { Fragment, useContext, useEffect, useRef, useState } from 'react';
import PageHeader from '../../components/PageHeader/PageHeader';
import './FellowshipGroupPage.scss';
import IRouteInfo from '../../interfaces/IRouteInfo';
import UserRoles, { UserRolesNames, UserRolesValues } from '../../data/UserRoles';
import { bookOutline, chevronDownCircleOutline, copy, createOutline, library, logOut, people, peopleSharp, personAddOutline, refresh, reload, share, sparkles, sync, trash } from 'ionicons/icons';
import { useDispatch, useSelector } from 'react-redux';
import ServerDBContext from '../../components/ServerDBContext/ServerDBContext';
import { SelectCurrentUser, SelectLoginStatus } from '../../store/UserSlice';
import { SelectGroup, SelectGroupIds, SelectGroupMembers, SelectIsGroupAdmin, UpdateGroup, UpdateLoadNewGroup } from '../../store/FellowshipSlice';
import { RefresherEventDetail } from '@ionic/core'; 
import IFellowshipGroup from '../../interfaces/IFellowshipGroup';
import { useHistory, useParams } from 'react-router-dom';
import { AppRouteInfo, AppRouteKeys } from '../../routes/AppRoutes';
import ReadingPlanRecordService from '../../services/ReadingPlanRecordService';
import IReadingPlanRecord from '../../interfaces/IReadingPlanRecord';
import { UserRouteInfo, UserRouteKeys } from '../../routes/UserRoutes';
import { Share } from '@capacitor/share';
import { GetMemberInfo } from '../../interfaces/IGroupMembers';
import { SelectActiveReadingPlanRecord, SelectReadingPlans, UpdateActivePlanByIdAsync } from '../../store/BibleStudySlice';
import { ReadingPlanCodes, createDefaultReadingPlanRecord } from '../../data/ReadingPlans';
import { Virtuoso } from 'react-virtuoso';

const FellowshipGroupPage: React.FC<IRouteInfo> = (props: IRouteInfo) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const dbService = useContext(ServerDBContext);
  const LoggedIn = useSelector(SelectLoginStatus);
  const currentUser = useSelector(SelectCurrentUser);
  const currentGroup = useSelector(SelectGroup);
  const isCurrentGroupAdmin = useSelector(SelectIsGroupAdmin);
  const memberInfo =  useSelector(SelectGroupMembers);
  const userGroupsIds = useSelector(SelectGroupIds);
  const ActiveReadingPlanRecord = useSelector(SelectActiveReadingPlanRecord);
  const readingPlans = useSelector(SelectReadingPlans); 
  const [showGeneratingNewCodeMessage, setShowGeneratingNewCodeMessage] = useState(false);
  const [toastSuccessMessage, setToastSuccessMessage] = useState('Success');
  const [toastSuccessDuration, setToastSuccessDuration] = useState(25000);
  const [displayToastSuccess, setDisplayToastSuccess] = useState(false);
  const [displayToastFailed, setDisplayToastFailed] = useState(false);
  const [toastFailedMessage, setToastFailedMessage] = useState('Error');
  const [showRemoveMemberConfirmation, setShowRemoveMemberConfirmation] = useState(false);
  const [removeMemberConfirmationEvent, setRemoveMemberConfirmationEvent] = useState<Event | undefined>(undefined);
  const [removeMemberInfo, setRemoveMemberInfo] = useState<{displayName: string, userId: string} | undefined>(undefined);
  const [showSyncPlanConfirmation, setShowSyncPlanConfirmation] = useState(false);
  const [syncPlanConfirmationEvent, setSyncPlanConfirmationEvent] = useState<Event | undefined>(undefined);
  const [planStartDate, setPlanStartDate] = useState('January 1, 2021');
  const [planTitle, setPlanTitle] = useState('Chronological Cross-Reference Bible Reading Plan');
  const [isAdmin, setIsAdmin] = useState(false);
  const inviteMembersRef = useRef<HTMLDivElement | null>(null);
  const groupPlanRef = useRef<HTMLDivElement | null>(null);
  const { nav } = useParams<{ nav: string; }>();
  const [showDeleteGroupConfirmation, setShowDeleteGroupConfirmation] = useState(false);
  const [showShareButton, setShowShareButton] = useState(false);
  const [loading, setLoading] = useState(false);
  const [groupRefreshed, setGroupRefreshed] = useState(false);
  const [groupReadingPlanRecord, setGroupReadingPlanRecord] = useState<IReadingPlanRecord | undefined>(undefined);
  const [groupPlanCode, setGroupPlanCode] = useState('');
  const [searchMemberText, setSearchMemberText] = useState('');
  const [searchMembersList, setSearchMembersList] = useState<{ id: string; displayName: string; role: UserRolesValues; }[]>([]);

  useEffect(() => {
    console.log('syncCode', currentGroup.syncCode);
    if(currentGroup && currentGroup.syncCode) {
      const codeData = ReadingPlanRecordService.interpretSyncCode!(currentGroup.syncCode);
      if (codeData)
      {
        setPlanStartDate(codeData.startDate.toLocaleDateString());
        setPlanTitle(codeData.readingPlan);
        setGroupPlanCode(codeData.readingPlanCode);

        ReadingPlanRecordService.getReadingPlanRecords().then(response => {
          if(response.Success) {
            const groupPlanRecord = response.Data?.find(plan => plan.groupId === currentGroup.id);
            if(groupPlanRecord) {
              setGroupReadingPlanRecord(groupPlanRecord);
            }
          }
        })
      }
    }
  }, [currentGroup]);

  useEffect(() => {
    if(memberInfo) {
      const groupMembers = currentGroup.memberIds.map(id => {
        if(memberInfo.hasOwnProperty(id)) {
          return { id, displayName: memberInfo[id].displayName, role: memberInfo[id].role};
        } else {
          return { id, displayName: 'CORRUPT MEMBER DATA', role: UserRoles.groupMember};
        }
      });
      setSearchMembersList(groupMembers);
    }
    return () => {}
  }, [currentGroup, memberInfo]);

  const updateSearchMemberList = (searchText: string) => {
    setSearchMemberText(searchText);
    if(memberInfo) {
      const groupMembers = currentGroup.memberIds.map(id => {
        if(memberInfo.hasOwnProperty(id)) {
          return { id, displayName: memberInfo[id].displayName, role: memberInfo[id].role};
        } else {
          return { id, displayName: 'CORRUPT MEMBER DATA', role: UserRoles.groupMember};
        }
      }).filter(memberList => searchText ? memberList.displayName.includes(searchText): true);
      setSearchMembersList(groupMembers);
    }
  }

  useIonViewDidEnter(async () => {
    setLoading(false);
    setGroupRefreshed(false);

    if (LoggedIn && isCurrentGroupAdmin) {
      setIsAdmin(true);
      Share.canShare().then(result => {
        if(result.value) {
          setShowShareButton(true);
        }
      });

      // Give the page a second to load
      const clearInterval = setTimeout(() => {
        switch(nav){
          case 'invite':
            inviteMembersRef.current?.scrollIntoView({behavior: "smooth", block: "start"});
            break;
          case 'plan':
            groupPlanRef.current?.scrollIntoView({behavior: "smooth", block: "start"});
            break;
        }  
        clearTimeout(clearInterval);
      }, 1000)
    }
  },[isCurrentGroupAdmin]);

  const copyGroupCode = () => {
    var tempInput = document.createElement("textarea");
    tempInput.style.cssText = "position: absolute; left: -1000px; top: -1000px";
    tempInput.value = joinCodeMessage;
    document.body.appendChild(tempInput);
    tempInput.select();
    document.execCommand("copy");
    document.body.removeChild(tempInput);
    setToastSuccessMessage('Message copied to Clipboard!')
    setToastSuccessDuration(1500);
    setDisplayToastSuccess(true);
  }
  
  const sendGroupInvite = () => {
    Share.share({
      title: `Bible Study Together Groups`,
      text: joinCodeMessage,
      url: `https://app.biblestudytogether.com/fellowship-group-join/${currentGroup.joinCode}`,
      dialogTitle: 'Invite New Group Members',
    });
  }

  // Note: the newlines and indents are preserved here when copying
  const joinCodeMessage = `You are invited to join our Bible Study Together group. Being part of our group allows you to easily read your Bible, pray, and communicate together with us using the app.
To get started go to: 
https://app.biblestudytogether.com/fellowship-group-join/${currentGroup.joinCode}

By going to the above link our group code will be automatically entered so you can just sign up. Once you have signed up you should never need this group code, but if you ever need it, here it is:
${currentGroup.joinCode}\n `;

  const joinCodeMessageHTML = <div>You are invited to join our Bible Study Together group.<br />
    Being part of our group allows you to<br />
    easily read your Bible, pray, and<br /> 
    communicate together with us using the app.<br />
    To get started go to:<br />
    <b>https://app.biblestudytogether.com/fellowship-group-join</b><br />
    Then fill out the form and enter the following<br />
    join group code:<br />
    <b>{currentGroup.joinCode}</b></div>;

  const regenerateGroupCode = async () => {
    setShowGeneratingNewCodeMessage(true);
    const response = await dbService?.updateJoinCode(currentGroup.id);
    if(response?.Success) {
      const updatedGroup = {...currentGroup, joinCode: response.Data}
      dispatch(UpdateGroup(updatedGroup));
    }
    setShowGeneratingNewCodeMessage(false);
  }

  const toggleAllowNewMembers = async () => {
    const updatedGroup: IFellowshipGroup = {...currentGroup, allowNewMembers: !currentGroup.allowNewMembers}
    const response = await dbService?.updateGroup(updatedGroup);
    if(response?.Success) {
      const updatedGroup = {...response.Data}
      dispatch(UpdateGroup(updatedGroup));
    }
  }

  const refreshGroupInfo = (event?: CustomEvent<RefresherEventDetail>) => {
    setLoading(true);
    dbService?.getUserGroups(currentUser.id, currentGroup.id).then(result => {
      if(result.Success){
        console.log(result.Data);
        const activeGroup = result.Data!.find(group => group.id === currentGroup.id);
        if(activeGroup) {
          dispatch(UpdateGroup(activeGroup));
        } else {
          setSearchMembersList([]);
          dispatch(UpdateLoadNewGroup(true));
          history.push(AppRouteInfo[AppRouteKeys.Fellowship].path, {direction: 'forward'});
        }
        setGroupRefreshed(true);
      } else {
        console.log("GroupLoadFailed");
      }
      if(event) {
        event.detail.complete();
      }
      setLoading(false);
    });
  }

  const removeMember = async (memberId: string) => {
    const removingMessage = 'Removing Member';
    if(toastSuccessMessage !== removingMessage && currentGroup.creatorId !== memberId) {
      setShowRemoveMemberConfirmation(false);
      setToastSuccessMessage(removingMessage);
      setToastSuccessDuration(25000);
      setDisplayToastSuccess(true);
      dbService?.removeMember(currentGroup, memberId)
        .then(result => {
          if(result.Success){
            setDisplayToastSuccess(false);
            setToastSuccessMessage('');
            if(currentUser.id === memberId){
              setSearchMembersList([]);
              dispatch(UpdateLoadNewGroup(true));
              history.push(AppRouteInfo[AppRouteKeys.Fellowship].path, {direction: 'forward'});
            } else {
              dispatch(UpdateGroup(result.Data));
            }
          } else {
            setToastSuccessMessage('');
            setDisplayToastSuccess(false);
            setToastFailedMessage(result.Message.UserMessage);
            setDisplayToastFailed(true);
          }
        });
    }
  }

  const deleteGroup = async (groupId: string) => {
    const deletingMessage = 'Deleting Group...';
    if(toastSuccessMessage !== deletingMessage) {
      setShowDeleteGroupConfirmation(false);
      setToastSuccessMessage(deletingMessage);
      setToastSuccessDuration(25000);
      setDisplayToastSuccess(true);
      dbService?.deleteGroup(groupId)
        .then(result => {
          if(result.Success){
            setToastSuccessMessage('');
            setDisplayToastSuccess(false);
            dispatch(UpdateLoadNewGroup(true));
              history.push(AppRouteInfo[AppRouteKeys.Fellowship].path, {direction: 'forward'});
          } else {
            setToastSuccessMessage('');
            setDisplayToastSuccess(false);
            setToastFailedMessage(result.Message.UserMessage);
            setDisplayToastFailed(true);
          }
        });
    }
  }

  // NOTE: DUPLICATE CODE - FellowshipPage.tsx line 334 - Remove when sync is automatic
  const syncBibleReadingPlan = async (syncCode: string | undefined) => {
    if(syncCode) {
      // Extract ReadingPlanRecord field from sync code
      const codeData = await ReadingPlanRecordService.interpretSyncCode!(syncCode);
      if (codeData) {
        const {startDate, sessionsPerDay, readingPlanCode} = codeData;
        ReadingPlanRecordService.getReadingPlanRecords().then(response => {
          const groupPlanRecord = response.Success ? response.Data?.find(record => record.groupId = currentGroup.id) : undefined;
          if(groupPlanRecord) {
            // if the reading plan code is the same then its the same plan, therefore update it
            if(groupPlanRecord.readingPlanCode === readingPlanCode) {
              const record = {...groupPlanRecord, startDate, sessionsPerDay}
              // updating current reading plan record with data extracted from the sync code
              ReadingPlanRecordService.updateReadingPlanRecord(record).then(result => {
                if(result.Success) {
                    UpdateActivePlanByIdAsync(dispatch, userGroupsIds, result.Data?.id);
                    console.log('updated synced bible reading schedule', codeData, syncCode);
                  } else {
                    setToastFailedMessage('Failed to create your synced Bible reading schedule.');
                    setDisplayToastFailed(true);
                  }
              });
            } else {
              // TO DO: Create Popup with Request to delete current group plan and create a new one, because it has changed
              setToastFailedMessage('Failed Sync: Your group has changed reading plans');
              setDisplayToastFailed(true);
            }
            
          } else {
            // if no reading plan was set up before...
            const newRecord: IReadingPlanRecord = {
              ...createDefaultReadingPlanRecord(readingPlanCode),
              sessionsPerDay, startDate,
              groupId: currentGroup.id,
              name: currentGroup.name
            }; 
            ReadingPlanRecordService.createReadingPlanRecord(newRecord).then(result => {
              if(result.Success) {
                setToastSuccessMessage('Your Bible schedule Reading has been synced with your group.');
                setDisplayToastSuccess(true);
              } else {
                setToastFailedMessage('Failed to create your synced Bible reading schedule.');
                setDisplayToastFailed(true);
              }
            });
          }
        });
      } else {
        setToastFailedMessage('Your group does not have a reading plan yet.');
        setDisplayToastFailed(true);
      }
    } else {
      setToastFailedMessage('Your group does not have a reading plan yet.');
      setDisplayToastFailed(true);
    }
  }

  const updateGroupReadingPlan = (groupId: string, readingPlanRecord?: IReadingPlanRecord) => {
    if(readingPlanRecord) {
      UpdateActivePlanByIdAsync(dispatch, userGroupsIds, readingPlanRecord.id);
      history.push(`${AppRouteInfo[AppRouteKeys.ReadingScheduler].rootPath}/${readingPlanRecord?.readingPlanCode}/${readingPlanRecord?.id}/${groupId}`, {direction: 'forward'});
    } else {
      const readingPlanCode = groupPlanCode ? groupPlanCode : '';
      if(readingPlanCode) {
        history.push(`${AppRouteInfo[AppRouteKeys.ReadingScheduler].rootPath}/${readingPlanCode}/new/${groupId}`, {direction: 'forward'});
      } else {
        history.push(`${AppRouteInfo[AppRouteKeys.BiblePlanSelector].rootPath}/`, {direction: 'forward'});
      }
    }  
  }

  const createNewGroupReadingPlan = (groupId: string) => {
    history.push(`${AppRouteInfo[AppRouteKeys.BiblePlanSelector].rootPath}/${groupId}`, {direction: 'forward'});
  }

  const groupMember = (index: number) => {
    return (
          <IonItem key={`groupMember-${index}`}>
            <Fragment>
              <IonLabel>{searchMembersList[index]?.displayName}</IonLabel>
              <IonNote className="group-member-role" slot="end">
                {UserRolesNames[searchMembersList[index]?.role]}
                {((memberInfo![currentUser.id].role === UserRoles.admin && searchMembersList[index]?.id !== currentUser.id) ||
                  (searchMembersList[index]?.role === UserRoles.groupMember && searchMembersList[index]?.id === currentUser.id)) ?
                  <IonIcon className="delete-group-member" icon={trash} onClick={(e) => {
                    setRemoveMemberConfirmationEvent(e.nativeEvent);
                    setRemoveMemberInfo({userId: searchMembersList[index]?.id, displayName: searchMembersList[index]?.displayName});
                    setShowRemoveMemberConfirmation(true);
                  }}></IonIcon> : 
                  searchMembersList[index]?.role === UserRoles.admin && searchMembersList[index]?.id === currentUser.id ?
                  <IonIcon className="delete-group-member" icon={trash} onClick={(e) => {
                    setShowDeleteGroupConfirmation(true);
                  }}></IonIcon> : null}
              </IonNote>
            </Fragment>
          </IonItem>);
  }
  
  const pageHeaderMenuContent =
    <IonList className="fellowship-page-menu-list">
      { isAdmin ?
      <div>
        <IonItem className="header-menu-item" onClick={() => history.push(UserRouteInfo[UserRouteKeys.FellowshipGroupProfile].path, {direction: 'forward'})}>
          <IonLabel>GROUP PROFILE</IonLabel>
          <IonIcon slot="start" icon={people}></IonIcon>
        </IonItem> 
        <IonItem className="header-menu-item" onClick={(e) => {
              setShowDeleteGroupConfirmation(true);
          }}>
            <IonLabel>DELETE GROUP</IonLabel>
            <IonIcon slot="start" icon={trash}></IonIcon>
        </IonItem>
      </div> :
        <div>
          <IonItem className="header-menu-item" onClick={(e) => {
            setSyncPlanConfirmationEvent(e.nativeEvent);
            setShowSyncPlanConfirmation(true);
          }}>
            <IonLabel>SYNC BIBLE PLAN</IonLabel>
            <IonIcon slot="start" icon={sync}></IonIcon>
          </IonItem>
          <IonItem className="header-menu-item" onClick={(e) => {
              setRemoveMemberConfirmationEvent(e.nativeEvent);
              setRemoveMemberInfo({userId: currentUser.id, displayName: currentUser.displayName!});
              setShowRemoveMemberConfirmation(true);
            }}>
              <IonLabel>LEAVE GROUP</IonLabel>
              <IonIcon slot="start" icon={trash}></IonIcon>
          </IonItem>
        </div>
      }
      <IonItem className="header-menu-item" onClick={()=>{
        dbService?.signOut();
        history.push(AppRouteInfo[AppRouteKeys.Fellowship].path, {direction: 'back'});
      }}>
        <IonLabel>LOGOUT</IonLabel>
        <IonIcon slot="start" icon={logOut}></IonIcon>
      </IonItem>
    </IonList>;

  return (
    <IonPage>
      <PageHeader {...props} showBackButton={true} menuContents={pageHeaderMenuContent}></PageHeader>
      {LoggedIn && 
      <IonContent className="fellowship-content">
        <IonRefresher slot="fixed" onIonRefresh={refreshGroupInfo} >
            <IonRefresherContent
                pullingIcon={chevronDownCircleOutline}
                pullingText="Pull to refresh"
                refreshingText="Refreshing...">
            </IonRefresherContent>
        </IonRefresher>
        <IonGrid fixed={true}>
          <IonRow >
            <IonCol>
            <IonCard mode="md" className="fellowship-group-card">
              <IonCardHeader>
                  <h2 className="group-details-title"><IonIcon className="group-details-title-icon" size="large" slot="start" icon={peopleSharp} /> {currentGroup.name + ' '} 
                    { isAdmin && <IonIcon icon={createOutline} className="fellowship-group-button" onClick={() => history.push(UserRouteInfo[UserRouteKeys.FellowshipGroupProfile].path, {direction: 'forward'})} /> }
                  </h2>
              </IonCardHeader>
              <IonCardContent>
              <div className="fellowship-group-details-divider">
                <IonCardTitle>{'Description '} 
                  { isAdmin && <IonIcon icon={createOutline} className="fellowship-group-button" onClick={() => history.push(UserRouteInfo[UserRouteKeys.FellowshipGroupProfile].path, {direction: 'forward'})} />}
                </IonCardTitle>
                <p>{currentGroup.description}</p>
                </div>
              </IonCardContent>
                
              <div className="fellowship-group-footer">
                <div className="fellowship-group-details-divider">
                <IonCardTitle>Group Members 
                  { !groupRefreshed && !loading ?
                      <IonIcon icon={reload} onClick={() => refreshGroupInfo()} className="fellowship-group-button"></IonIcon> :
                      loading ? <IonSpinner name="dots"></IonSpinner> : 
                      <span className="fellowship-group-refreshed-notice"> - Refreshed</span>
                  }
                </IonCardTitle>
                  <IonList>
                  {
                    (isAdmin) && <IonItem>
                      <IonLabel color="tertiary"><b>ALLOW NEW MEMBERS</b></IonLabel>
                      <IonToggle color="tertiary" slot="end" checked={currentGroup.allowNewMembers} onClick={toggleAllowNewMembers}></IonToggle>
                    </IonItem>
                  }
                  </IonList>
                  <IonSearchbar 
                    value={searchMemberText} 
                    placeholder="Search for Group Members"
                    onIonInput={e => updateSearchMemberList(e.target.value?.toString()!)}
                    className="group-member-search-box" />
                        
                      
                  <IonList>
                  {
                    searchMembersList ?
                          <Virtuoso
                            style={{ height: searchMembersList.length >= 3 ? '200px' : '100px' }}
                            totalCount={searchMembersList.length}
                            itemContent={index => groupMember(index)}
                          /> :
                        <div className="browser-loading-days">
                          <IonSpinner name="dots" color="medium" />
                          <p className="loading-text">LOADING MEMBERS</p>
                        </div>
                  }
                  </IonList>
                  <div className="fellowship-group-size">GROUP SIZE: {currentGroup.memberIds.length} OUT OF 500 MAX</div>
                </div>
                {
                  isAdmin ?
                    <div>
                      <div ref={inviteMembersRef} className="fellowship-group-details-divider">
                        <IonCardTitle><IonIcon icon={personAddOutline} /> Invite Members</IonCardTitle>
                        <div className="fellowship-group-code">
                          <p className="ion-text-left"><i>Invite new members to your group by { showShareButton && 'sending an invite or '}copying and pasting the message below into an email or text message and then send it to them.</i></p> 
                          <p className="ion-text-left"><i><b>NOTE:</b> Only share this with people you want to invite because anyone with the code can join your group.</i></p>
                          { showShareButton && <IonButton color="tertiary" onClick={sendGroupInvite}>
                            <IonIcon slot="start" icon={share} color="light"></IonIcon>
                            <IonLabel>SEND INVITE</IonLabel>
                          </IonButton>
                          }   
                          <IonButton color="tertiary" onClick={copyGroupCode}>
                            <IonIcon slot="start" icon={copy} color="light"></IonIcon>
                            <IonLabel>COPY MESSAGE</IonLabel>
                          </IonButton>
                          <div className="fellowship-code-text">{joinCodeMessageHTML}</div>
                        <div>
                            <IonButton color="tertiary" onClick={regenerateGroupCode}>
                              <IonIcon slot="start" icon={refresh} color="light"></IonIcon>
                              <IonLabel>Generate New Code</IonLabel>
                            </IonButton>
                            { showGeneratingNewCodeMessage && 
                              <p><IonSpinner name="dots" color="tertiary"/><br />Generating New JOIN CODE</p> }
                          </div>
                        </div>
                      </div>
                      <div ref={groupPlanRef} className="fellowship-group-details-divider">
                        <IonCardTitle><IonIcon icon={bookOutline} /> Group Bible Reading Plan</IonCardTitle>
                        <div className="fellowship-group-sync-plan">
                          { groupReadingPlanRecord && <p className="fellowship-group-sync-plan-info">
                            <i><b>PLAN NAME:</b> {groupReadingPlanRecord?.name}<br /></i> 
                            <i><b>PLAN TYPE:</b> {groupReadingPlanRecord?.readingPlan}</i><br />
                            <i><b>START DATE:</b> {groupReadingPlanRecord?.startDate?.toLocaleDateString()}</i>
                          </p>}
                          <p className="ion-text-left">{groupReadingPlanRecord ? <span>Your group's reading plan is named after your group's name. To update it, click the 'UPDATE READING PLAN' button below or to change it to different plan choose "NEW READING PLAN". You can set your group's plan to your personal active plan from the app home page or by clicking on the books icon <IonIcon icon={library}></IonIcon> in the header of the Bible reading page.</span> : <span>Your group does not yet have a reading plan. Click 'New READING PLAN' below to set one up.</span>}</p>
                            { groupReadingPlanRecord && <IonButton color="tertiary" onClick={() => updateGroupReadingPlan(currentGroup?.id, groupReadingPlanRecord)}>
                              <IonIcon slot="start" icon={refresh} color="light"></IonIcon>
                              <IonLabel>UPDATE READING PLAN</IonLabel>
                            </IonButton> }
                             <IonButton color="tertiary" onClick={() => createNewGroupReadingPlan(currentGroup?.id)}>
                              <IonIcon slot="start" icon={sparkles} color="light"></IonIcon>
                              <IonLabel>New READING PLAN</IonLabel>
                            </IonButton>
                        </div>
                      </div>
                    </div> : 
                    <div ref={groupPlanRef} className="fellowship-group-details-divider">
                    <IonCardTitle><IonIcon icon={bookOutline} /> Group Bible Reading Plan</IonCardTitle>
                    <div className="fellowship-group-sync-plan">
                      { groupReadingPlanRecord && <p className="fellowship-group-sync-plan-info">
                        <i><b>PLAN NAME:</b> {groupReadingPlanRecord?.name}<br /></i>
                        <i><b>PLAN TYPE:</b> {groupReadingPlanRecord?.readingPlan}</i><br />
                        <i><b>START DATE:</b> {groupReadingPlanRecord?.startDate?.toLocaleDateString()}</i>
                      </p>}
                      <p className="ion-text-left">{groupReadingPlanRecord ? <span>Your Bible reading plan is named after your group. You can set it as the active plan from the app home page or by clicking on the books icon <IonIcon icon={library}></IonIcon> in the header of the Bible reading page. If you believe you reading plan is out of sync with your group, you can either restart the app or click the CHECK FOR PLAN UPDATES button below.</span> : <span>Your group does not yet have a reading plan. Please contact your group admin to have them set this up. If your admin has set up your group reading plan, but you are not seeing it here either restart the app or click the CHECK FOR PLAN UPDATES button below.</span> }</p>
                      <IonButton color="tertiary" onClick={() => dispatch(UpdateLoadNewGroup(true))}>
                        <IonIcon slot="start" icon={refresh} color="light"></IonIcon>
                        <IonLabel>CHECK FOR PLAN UPDATES</IonLabel>
                      </IonButton>
                    </div>
                  </div>
                }
              </div>
            </IonCard>
            </IonCol>
          </IonRow>
        </IonGrid>
        {/* Delete confirmation pop up */}
        <IonPopover
            mode="md"
            isOpen={showRemoveMemberConfirmation}
            event={removeMemberConfirmationEvent}
            onDidDismiss={() => {
                setShowRemoveMemberConfirmation(false); 
                setRemoveMemberConfirmationEvent(undefined);
            }}
        > 
          <div>
            <div className="remove-user-pop-over-message">
              REMOVE<br /><b>{removeMemberInfo?.displayName}</b><br />FROM THIS GROUP?
              <p>
                <b>Note:</b> <i>If you select yes, this person's group reading plan will be deleted and they will need to re-sign up to this group to be a member again.
                Also, you may need to re-generate your group join code at the bottom of this page 
                if you don't want this person to rejoin your group.</i>
              </p>
            </div>
            <IonButton expand="block" color="success" onClick={() => removeMemberInfo && removeMember(removeMemberInfo.userId)}>
              <IonIcon icon={trash} slot="start"></IonIcon>
              <IonLabel>YES</IonLabel>
            </IonButton>
            <IonButton expand="block" color="danger" onClick={() => setShowRemoveMemberConfirmation(false)}>
              <IonLabel>CANCEL</IonLabel>
            </IonButton>
          </div>
        </IonPopover>

         {/* Sync Plan confirmation pop up */}
         <IonPopover
            mode="md"
            isOpen={showSyncPlanConfirmation}
            event={syncPlanConfirmationEvent}
            onDidDismiss={() => {
                setShowSyncPlanConfirmation(false);
            }}
        > 
          <div>
            <div className="remove-user-pop-over-message">
              Are you sure you want to synchronize your Bible reading schedule with your group?
              <p>
                <b>Note:</b> <i>If you currently have a Bible reading schedule stored on this 
                  device it will be overwritten and set to your group's schedule. Also, only this device
                  will be synced. If you want to use multiple phones, tablets, or computers each will need to be synced.</i>
              </p>
            </div>
            <IonButton expand="block" color="success" onClick={() => {
              syncBibleReadingPlan(currentGroup.syncCode);
              setShowSyncPlanConfirmation(false);
              }}>
              <IonIcon icon={trash} slot="start"></IonIcon>
              <IonLabel>YES</IonLabel>
            </IonButton>
            <IonButton expand="block" color="danger" onClick={() => setShowSyncPlanConfirmation(false)}>
              <IonLabel>CANCEL</IonLabel>
            </IonButton>
          </div>
        </IonPopover>

        <IonAlert
          isOpen={showDeleteGroupConfirmation}
          onDidDismiss={() => setShowDeleteGroupConfirmation(false)}
          cssClass='my-custom-class'
          header={'WARNING: CONFIRM'}
          subHeader={currentGroup.memberIds.length === 1 ? 'Are you sure you want to delete this group?': ''}
          message={currentGroup.memberIds.length > 1 ?
             `You must first remove all the other members of this group by using the trash can next to their name before you can remove yourself from this group and delete group it.` :
              `Note: Removing the group creator from the group will delete your entire group. Your group reading plan and all your group posts will be permanently deleted and cannot be recovered. Prayers and other reading plans on this device will NOT be altered.`}
          buttons={currentGroup.memberIds.length > 1 ? [
            {
              text: 'Cancel',
              role: 'cancel',
              cssClass: 'secondary',
              handler: () => {
                console.log('Confirm Cancel: DELETE GROUP');
              }
            }] : [
            {
              text: 'Cancel',
              role: 'cancel',
              cssClass: 'secondary',
              handler: () => {
                console.log('Confirm Cancel: DELETE GROUP');
              }
            },
            {
              text: 'YES',
              handler: () => {
                deleteGroup(currentGroup.id);
              }
            }
          ]}
        />

        <IonToast color="success"
          isOpen={displayToastSuccess}
          onDidDismiss={() => setDisplayToastSuccess(false)}
          message={toastSuccessMessage}
          duration={toastSuccessDuration} />
        <IonToast color="danger"
          isOpen={displayToastFailed}
          onDidDismiss={() => setDisplayToastFailed(false)}
          message={toastFailedMessage}
          duration={2500} />
      </IonContent>
    }
    </IonPage>
  );
};

export default FellowshipGroupPage;